export const LANG = {
  EN: "EN",
  ES: "ES",
}



// WEBPACK FOOTER //
// ./src/const/lang.js